export default __webpack_public_path__ + "static/media/Queen-Annes-Lace_L1.06efabc6.png";